var _rect, _path, _circle, _circle2, _rect2, _rect3, _text, _rect4, _text2, _path2, _path3, _rect5, _text3, _rect6, _rect7, _rect8, _path4, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenomicformatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    rx: 48,
    fill: "#101114"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v760H0z",
    fill: "url(#grid)",
    opacity: 0.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 136,
    r: 238,
    fill: "#2DD4BF",
    opacity: 0.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 612,
    r: 255,
    fill: "#F59E0B",
    opacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 114,
    width: 936,
    height: 532,
    rx: 36,
    fill: "#191B20",
    stroke: "rgba(255,255,255,.14)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 162,
    width: 298,
    height: 54,
    rx: 14,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 198,
    fill: "#101114",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 27,
    fontWeight: 900
  }, "Genomic Formatter")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 276,
    width: 332,
    height: 270,
    rx: 30,
    fill: "rgba(45,212,191,.12)",
    stroke: "rgba(45,212,191,.4)",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 336,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "GFF")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274 404c52-58 108 58 160 0M274 452c52-58 108 58 160 0",
    stroke: "#2DD4BF",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M588 414h110M660 374l44 40-44 40",
    stroke: "#F59E0B",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 748,
    y: 276,
    width: 250,
    height: 270,
    rx: 30,
    fill: "rgba(255,255,255,.07)",
    stroke: "rgba(255,255,255,.13)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 336,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "XLSX")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 382,
    width: 146,
    height: 18,
    rx: 9,
    fill: "#94A3B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 428,
    width: 146,
    height: 18,
    rx: 9,
    fill: "#94A3B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 474,
    width: 146,
    height: 18,
    rx: 9,
    fill: "#94A3B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M852 366v144M894 366v144",
    stroke: "rgba(255,255,255,.15)",
    strokeWidth: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 584,
    width: 836,
    height: 18,
    rx: 9,
    fill: "rgba(255,255,255,.12)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 584,
    width: 612,
    height: 18,
    rx: 9,
    fill: "#2DD4BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48",
    stroke: "white",
    strokeOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenomicformatter);
export default __webpack_public_path__ + "static/media/genomicformatter.f4bb7b03575c2d9f7dda677d1c1dcb0e.svg";
export { ForwardRef as ReactComponent };